import Layout from "components/layout/layout";
import { marked } from "helpers/helpers";
import DataProvider from "hoc/data_provider";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import "./alumini.css";

const AluminiTrust = () => {
    return (
        <DataProvider
            endPoint="/web/aluminis/"
            component={AluminiAssociationComponent}
        />
    );
};

export default AluminiTrust;

const AluminiAssociationComponent = ({ data }) => {
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const res = data.filter((item) => item.type === "trust-details");
        setFilteredData(res);
    }, []);

    return (
        <Layout
            title="Alumni Trust Details"
            breadcrumb={[
                {
                    name: "Home",
                    path: "/",
                },
                {
                    name: "Alumni Trust Details",
                    path: "/alumini-trust-details",
                },
            ]}
        >
            <div className="alumini-data-wrapper">
                {filteredData.map((item, index) => {
                    return (
                        <div key={item._id} className="alumini_item">
                            <p
                                dangerouslySetInnerHTML={marked(
                                    item.description
                                )}
                            ></p>
                        </div>
                    );
                })}
            </div>
        </Layout>
    );
};
